/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyAddNoteRequestDTO
 */
export interface SurveyAddNoteRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof SurveyAddNoteRequestDTO
     */
    note: string;
}

export function SurveyAddNoteRequestDTOFromJSON(json: any): SurveyAddNoteRequestDTO {
    return SurveyAddNoteRequestDTOFromJSONTyped(json, false);
}

export function SurveyAddNoteRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyAddNoteRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function SurveyAddNoteRequestDTOToJSON(value?: SurveyAddNoteRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
    };
}

